import { render, staticRenderFns } from "./Fpcx.vue?vue&type=template&id=fd01f600&scoped=true"
import script from "./Fpcx.vue?vue&type=script&lang=js"
export * from "./Fpcx.vue?vue&type=script&lang=js"
import style0 from "./Fpcx.vue?vue&type=style&index=0&id=fd01f600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01f600",
  null
  
)

export default component.exports